/**
 * @fileoverview Context for sharing backtest result data with sidebar
 */

import React, { createContext, useContext, useState, ReactNode } from 'react';
import type { BacktestData } from '../hooks/backtest/useBacktestResultData';

interface BacktestResultContextType {
    backtestData: BacktestData | null;
    setBacktestData: (data: BacktestData | null) => void;
    showPriceChart: boolean;
    setShowPriceChart: (show: boolean) => void;
}

const BacktestResultContext = createContext<BacktestResultContextType | null>(null);

export const useBacktestResultContext = () => {
    const context = useContext(BacktestResultContext);
    if (!context) {
        throw new Error('useBacktestResultContext must be used within a BacktestResultProvider');
    }
    return context;
};

export const useBacktestResultContextOptional = () => {
    return useContext(BacktestResultContext);
};

interface BacktestResultProviderProps {
    children: ReactNode;
}

export const BacktestResultProvider: React.FC<BacktestResultProviderProps> = ({ children }) => {
    const [backtestData, setBacktestData] = useState<BacktestData | null>(null);
    const [showPriceChart, setShowPriceChart] = useState(false);

    return (
        <BacktestResultContext.Provider value={{
            backtestData,
            setBacktestData,
            showPriceChart,
            setShowPriceChart
        }}>
            {children}
        </BacktestResultContext.Provider>
    );
};
